const mimeTypes = ["image/jpeg"];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "" && (ext === "jpg" || ext === "jpeg")) {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "image/jpeg";
}